import React from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { AuthSplitLayout } from '../components/Auth/AuthShell'
import { resolveAccountCreatedRole } from '../constants/accountCreated'
import { homePathForRole } from '../utils/routes'

export default function AccountCreated() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const role = searchParams.get('role') || 'GP'
  const config = resolveAccountCreatedRole(role)
  const home = homePathForRole(role)

  return (
    <AuthSplitLayout
      title={
        <>
          Welcome to
          <br />
          RotationStreet
        </>
      }
      description="You're now part of the global network connecting Chinese GPs with LPs worldwide. Your AI-powered investment platform is ready."
      marketingPanel="welcome"
    >
      <div className="auth-success-icon">✅</div>
      <h1 className="auth-success-title">{config.title}</h1>
      <p className="auth-success-subtitle">
        {config.subtitle.split('\n').map((line, i) => (
          <React.Fragment key={i}>
            {line}
            {i === 0 && <br />}
          </React.Fragment>
        ))}
      </p>

      <div className="auth-next-steps">
        <h3>What&apos;s next?</h3>
        {config.steps.map((step, i) => (
          <div key={step.title} className="auth-step-item">
            <span className="auth-step-num">{i + 1}</span>
            <span className="auth-step-text">
              <strong>{step.title}</strong> — {step.text}
            </span>
          </div>
        ))}
      </div>

      <button type="button" className="auth-btn-cta" onClick={() => navigate(home)}>
        {config.cta}
      </button>
      <Link to="/login" className="auth-secondary-link">
        Back to Log In
      </Link>
    </AuthSplitLayout>
  )
}
